import { Config } from 'src/config/config';

export function generateMsTeamsSsoUrl(identityProvider: string, state: unknown): string {
  return `https://${Config.CognitoDomain}/oauth2/authorize?identity_provider=${identityProvider}&redirect_uri=${Config.MsRedirectURL}&response_type=CODE&client_id=${Config.CognitoClientId}&state=${state}&scope=aws.cognito.signin.user.admin`;
}
